window.addEventListener('load', function () {
    const paralaxEls = document.querySelectorAll('main .paralax');
    if (!paralaxEls.length) return;

    const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
    const HEADER = 9 * rem;

    function check(el) {
        const firstCol = el.querySelector('.wp-block-column');
        if (!firstCol) return;
        el.classList.toggle('inactive-paralax', firstCol.offsetHeight > window.innerHeight - HEADER);
    }

    paralaxEls.forEach(check);

    window.addEventListener('resize', () => paralaxEls.forEach(check), { passive: true });
});

//# sourceMappingURL=paralax.js.map
